import type { IconData } from '@stacksjs/iconify-core'

export const cloudy: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M399.667 264.875v-3.813c0-79.4-64.6-144-144-144c-2.2 0-4.391.057-6.569.156a116.689 116.689 0 1 0-136.783 130.226a145 145 0 0 0-.648 13.618v3.813a116.633 116.633 0 0 0 20.62 231.425h246.759a116.633 116.633 0 0 0 20.621-231.427ZM48.75 132.688a84.677 84.677 0 0 1 168.705-10.47a144.6 144.6 0 0 0-98.59 93.876a84.81 84.81 0 0 1-70.115-83.406M379.046 464.3H132.287a84.619 84.619 0 0 1-3.9-169.148l15.277-.69v-33.4a112 112 0 1 1 224 0v33.4l15.277.69a84.619 84.619 0 0 1-3.9 169.148Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cloudy
